import React from 'react';
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import Page from "../Components/Page";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {Breadcrumbs} from "../Components/Breadcrumbs";

const GeographyParentageService = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/geographyParentage/`;
    const {loading, data} = useServiceBase({endpointUrl});
    const customColumns = [
        {header: "Parent Market Tag", accessorKey: "parent_market_tag"},
        {header: "Parent OP's Description", accessorKey: "parent_ops_description"},
        {header: "Parent OP's ID", accessorKey: "parentId"},
        {header: "Parent SDN Market Description", accessorKey: "parent_sdn_description"},
        {header: "Parent SDN Market ID", accessorKey: "parent_sabrina_market_id"},
        {header: "Child Market Tag", accessorKey: "child_market_tag"},
        {header: "Child OP's Description", accessorKey: "child_ops_description"},
        {header: "Child OP's ID", accessorKey: "childId"},
        {header: "Child SDN Market Description", accessorKey: "child_sdn_description"},
        {header: "Child SDN Market ID", accessorKey: "child_sabrina_market_id"}
    ]

    return (<Page name={"Geography Parentage"}
                  breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Geography"}, {label: "Geography Parentage"}]}/>}
            >
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={customColumns}
                editable={false}
                initialState={{ pagination: { pageSize: 25 }, sorting: [{ id: "parentId", desc: false }] }}
            />
        </LoadingWrapper>
    </Page>);
};

export default GeographyParentageService;